import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EAlertType, requestAuthentication } from 'shared/actions/authentication';

import { trackFirstMessageClick } from './tracking';
import { openChat } from '../../actions/chat';
import { SendMessageButton } from '../../components/SendMessageButton/SendMessageButton';
import { PopupOwnOfferContainer } from '../../components/popups/own_offer/container';
import { getAgentAvailability, selectOffer, selectUser } from '../../selectors';
import { getAgent } from '../../selectors/newObject/getAgent';
import { selectIsChatsEnabled } from '../../selectors/offerChat';

export const SendMessageButtonContainer = () => {
  const dispatch = useDispatch();
  const offer = useSelector(selectOffer);
  const agentAvailability = useSelector(getAgentAvailability);
  const agent = useSelector(getAgent);
  const user = useSelector(selectUser);
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const isAgentNotAvailable = agentAvailability && !agentAvailability.available;
  const type = isAgentNotAvailable ? 'open_message' : undefined;
  const [isOwnOfferPopupOpen, setOwnOfferPopupOpen] = React.useState(false);

  const onClick = () => {
    trackFirstMessageClick(offer, agent);

    if (!user || !user.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => openChat(type),
          alert: EAlertType.Chats,
        }),
      );

      return;
    }

    if (user && user.realtyUserId === offer.userId) {
      setOwnOfferPopupOpen(true);

      return;
    }

    dispatch(openChat(type));
  };

  const ownOfferPopupClose = () => setOwnOfferPopupOpen(false);

  if (!(isChatsEnabled && !offer.dealRentVersion)) {
    return null;
  }

  return (
    <>
      <PopupOwnOfferContainer isOpen={isOwnOfferPopupOpen} onClose={ownOfferPopupClose} />

      <SendMessageButton>
        <Button theme="fill_secondary" size="M" onClick={onClick} fullWidth>
          Написать
        </Button>
      </SendMessageButton>
    </>
  );
};
